import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { Spin } from 'antd';
import NewRetainerClientAssignmentDiscussionTopicForm from '../forms/NewRetainerClientAssignmentDiscussionTopicForm';
import DiscussionGroup from '../components/DiscussionGroup';

import QUERY from '../graphql/queries/allRetainerClientAssignmentDiscussionTopicsQuery.graphql';

const DiscussionGroupPage = ({ match }) => (
  <div>
    <h2>Discussions</h2>
    <div className="contentBox" style={{ marginBottom: 20 }}>
      <Query
        variables={{ retainerClientAssignmentId: parseInt(match.params.assignmentId, 10) }}
        query={QUERY}
        pollInterval={60000}
      >
        {({ loading, error, data, refetch }) => {
          if (loading) return <Spin />;
          if (error) return error;

          const { discussionTopics } = data;
          if (Array.isArray(discussionTopics) && discussionTopics.length > 0) {
            return <DiscussionGroup topics={discussionTopics} refetchQuery={refetch} />;
          }
          return <p>No existing topics.</p>;
        }}
      </Query>
    </div>
    <div className="contentBox">
      <h2>Create new topic</h2>
      <NewRetainerClientAssignmentDiscussionTopicForm
        retainerClientAssignmentId={parseInt(match.params.assignmentId, 10)}
      />
    </div>
  </div>
);

DiscussionGroupPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      assignmentId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default DiscussionGroupPage;



// WEBPACK FOOTER //
// ./src/pages/DiscussionGroupPage.jsx